;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { personalizedResource } from '@/lib/resources/personalized-resource';

// types
import type { ContentServiceVideoObject } from '@/lib/types/api/content-service'

// Distinct from the `viewing-history` percentage atom: these are complete video
// objects, needed by the My List viewing history page.
export const myListViewingHistory = personalizedResource<ContentServiceVideoObject>({
  key: 'myListViewingHistory',
  endpoint: '/api/profile/viewing-history/',
  select: (json) => (json as { myListViewingHistoryData: ContentServiceVideoObject[] | null }).myListViewingHistoryData,
})
